<template>
  <section :class="['page-hero', { 'has-media': !!image }]">
    <div class="page-hero-inner shell">
      <div class="page-hero-copy">
        <p class="eyebrow">
          <span class="eyebrow-line"></span>
          {{ eyebrow }}
        </p>

        <h1 class="display-1">
          {{ title }}
          <span v-if="subtitle">{{ subtitle }}</span>
        </h1>

        <p v-if="lead" class="lead page-hero-lead">{{ lead }}</p>

        <slot name="after-lead" />
      </div>

      <figure v-if="image" class="page-hero-media">
        <img :src="image" :alt="imageAlt" />
        <figcaption v-if="imageCaption">{{ imageCaption }}</figcaption>
      </figure>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageHero",

  props: {
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    lead: { type: String, default: "" },
    image: { type: String, default: "" },
    imageAlt: { type: String, default: "" },
    imageCaption: { type: String, default: "" },
  },
};
</script>

<style scoped>
.page-hero {
  position: relative;
  z-index: 2;
  padding: 156px 0 72px;
}

.page-hero-inner {
  display: grid;
  gap: 56px;
  align-items: center;
}

.page-hero.has-media .page-hero-inner {
  grid-template-columns: minmax(0, 1.08fr) minmax(340px, 0.92fr);
}

.page-hero-copy {
  max-width: 820px;
}

.page-hero-lead {
  max-width: 700px;
  margin: 26px 0 0;
}

.page-hero-media {
  position: relative;
  margin: 0;
  border: 1px solid var(--line);
  background: var(--surface);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.page-hero-media img {
  display: block;
  width: 100%;
  height: 420px;
  object-fit: cover;
}

.page-hero-media figcaption {
  padding: 16px 20px;
  border-top: 1px solid var(--line-soft);
  color: var(--muted-light);
  font-size: 11px;
  letter-spacing: 0.06em;
  line-height: 1.6;
}

@media (max-width: 1080px) {
  .page-hero.has-media .page-hero-inner {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .page-hero-media img {
    height: 320px;
  }
}

@media (max-width: 760px) {
  .page-hero {
    padding: 118px 0 48px;
  }

  .page-hero-media img {
    height: 240px;
  }
}
</style>
